import { useCallback } from 'react';

import { Filter, FilterResultStatus } from '@/components/filter';

import { usePhoneNumbersListStore } from '@/store/phone-numbers-list.store';
import type { PhoneNumberConfiguration } from '@/types/phone-number.type';

export const PhoneNumberHeader = ({
  phoneNumbers,
}: {
  phoneNumbers: PhoneNumberConfiguration[];
}) => {
  const { setQuery, query, reset } = usePhoneNumbersListStore();

  const handleClearQuery = useCallback(() => setQuery(''), [setQuery]);

  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center gap-3">
        <Filter
          placeholder="Search by name or phone number..."
          onFilter={setQuery}
          initialValue={query}
          onClear={handleClearQuery}
        />
      </div>

      {query && (
        <FilterResultStatus
          resultsCount={phoneNumbers.length}
          onReset={reset}
          message="No phone numbers match your search"
        />
      )}
    </div>
  );
};
